'use client'

export { GlobalErrorPage as default } from '../domain/error-page'
